import { Card, Row, Col, Form, Checkbox, Input, DatePicker } from "antd";
import { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update_narrative_form } from "../../actions/form_slice";
import { debounce } from "lodash";

const NARRATIVE = forwardRef(({ onValuesChange, agentName }, ref) => {
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getFieldsError: form.getFieldsError,
    validateFields: form.validateFields,
    resetFields: form.resetFields,
    setFieldsValue: form.setFieldsValue,
    submit: form.submit,
    getFieldsValue: form.getFieldsValue,
    setFieldValue: form.setFieldValue,
  }));

  const dispatch = useDispatch();
  const formData = useSelector((state) => state.form.narrative_form_type);

  const handleFormChange = debounce((changedValues) => {
    dispatch(update_narrative_form(changedValues));
    onValuesChange(formData);
  }, 300);

  return (
    <Form
      form={form}
      initialValues={{ "Worker Name": agentName }}
      onValuesChange={handleFormChange}
      // onFinish={props.onFinish}
      labelAlign="justify"
      layout="horizontal"
      labelWrap
      wrapperCol={{
        flex: 1,
      }}
    >
      <Form.Item name="Documentation/Notes:" label="Documentation/Notes:">
        <Input style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="Periodic Report procedures used to establish new certification period."
      >
        <Checkbox value="Periodic Report procedures used to establish new certification period.">
          Periodic Report procedures used to establish new certification period.
        </Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="Verbal explanation of work requirements offered to client unsuccessful."
      >
        <Checkbox value="Verbal explanation of work requirements offered to client unsuccessful.">
          Verbal explanation of work requirements offered to client
          unsuccessful.
        </Checkbox>
      </Form.Item>
      <Form.Item
        name="Worker Name"
        label="Worker Name"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input style={{ width: "100%" }} />
      </Form.Item>
      <Row>
        <label>
          BE SURE ALL TASKS ASSOCIATED WITH THE CASE HAVE BEEN CLAIMED, WORKED,
          AND COMPLETED.
        </label>
      </Row>
    </Form>
  );
});
export default NARRATIVE;
